/** The representation of a "Core Based Statistical Area". */
export default interface CBSA {
  /** The unique identifier for the CBSA. */
  cbsaCode: string;

  /** The type of CBSA. */
  cbsaType: CBSAType;

  /**  */
  name: string;
}

/** The type of CBSA. */
enum CBSAType {
  Unknown = "Unknown",
  Metro = "Metro",
  Micro = "Micro",
}

export { CBSAType };
